import { ACTIONS } from '../pm-plugins/actions';
import { stateKey } from '../pm-plugins/plugin-key';
import { getIdentifier } from '../pm-plugins/utils/media-common';
export var showMediaViewer = function showMediaViewer(media) {
  return function (_ref) {
    var tr = _ref.tr;
    tr.setMeta(stateKey, {
      type: ACTIONS.SHOW_MEDIA_VIEWER,
      mediaViewerSelectedMedia: media,
      isMediaViewerVisible: true
    });
    return tr;
  };
};
export var hideMediaViewer = function hideMediaViewer(_ref2) {
  var tr = _ref2.tr;
  tr.setMeta(stateKey, {
    type: ACTIONS.HIDE_MEDIA_VIEWER,
    mediaViewerSelectedMedia: null,
    isMediaViewerVisible: false
  });
  return tr;
};
export var trackMediaPaste = function trackMediaPaste(attrs) {
  return function (_ref3) {
    var tr = _ref3.tr;
    var identifier = getIdentifier(attrs);
    tr.setMeta(stateKey, {
      type: ACTIONS.TRACK_MEDIA_PASTE,
      identifier: identifier
    });
    return tr;
  };
};